import React from "react";

export default function App() {
  return (
    <div className="min-h-screen bg-black text-white font-sans">
      <header className="text-center py-12">
        <h1 className="text-4xl md:text-6xl font-bold">HyperLiq</h1>
        <p className="mt-4 text-xl text-gray-400">The Fastest Path to Bitcoin + Monad Liquidity</p>
        <div className="mt-6 space-x-4">
          <a href="https://gethyperliq.io" className="px-6 py-3 bg-white text-black rounded-full font-semibold">Visit gethyperliq.io</a>
          <a href="#" className="px-6 py-3 border border-white rounded-full">GitHub</a>
        </div>
      </header>
      <section className="py-16 px-6 md:px-20 text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-8">Why HyperLiq?</h2>
        <div className="grid md:grid-cols-3 gap-8 text-left">
          <div><h3 className="text-xl font-semibold mb-2">⛓️ Dual-Chain Liquidity</h3><p>Seamlessly bridge and trade across Bitcoin L2 and Monad at high speed and low cost.</p></div>
          <div><h3 className="text-xl font-semibold mb-2">🚀 Built for Speed</h3><p>Experience execution speeds designed for modern DeFi—from sniping to LP strategies.</p></div>
          <div><h3 className="text-xl font-semibold mb-2">🔒 Non-Custodial + Secure</h3><p>Smart contract-based trading with native wallet login. You own your keys.</p></div>
        </div>
      </section>
      <section className="py-16 px-6 md:px-20 text-center bg-gray-900">
        <h2 className="text-3xl md:text-5xl font-bold mb-8">Roadmap</h2>
        <ol className="space-y-6 max-w-3xl mx-auto text-left">
          <li><span className="font-bold">✅ Phase 1:</span> Landing page, GitHub repo, pitch deck</li>
          <li><span className="font-bold">🔜 Phase 2:</span> Smart contract MVP, testnet liquidity testing</li>
          <li><span className="font-bold">🚀 Phase 3:</span> Mainnet launch + hyper-speed UI</li>
          <li><span className="font-bold">🌍 Phase 4:</span> Multi-chain expansion and LP incentives</li>
        </ol>
      </section>
      <section className="py-16 px-6 md:px-20 text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-8">Contact Us</h2>
        <p className="text-lg text-gray-400">Questions? Opportunities? Reach out anytime.</p>
        <a href="mailto:team@gethyperliq.io" className="mt-4 inline-block text-white underline">team@gethyperliq.io</a>
      </section>
      <footer className="text-center py-12 text-gray-600 text-sm">
        © 2025 HyperLiq — <a href="https://gethyperliq.io" className="underline">gethyperliq.io</a>
      </footer>
    </div>
  );
}